import './bootstrap'
import './sprite'
import * as modules from './modules'

import.meta.glob([
    '../images/**'
])

// Some functionalities should be loaded immediately instead of on init.
modules.recaptcha()
modules.tinySliders()

document.addEventListener('livewire:init', () => {
    Livewire.hook('morph.added', () => {
        modules.compare.init()
    })
})

document.addEventListener('DOMContentLoaded', () => {
    // Order matters!
    modules.images()
    modules.imageZoom()
    modules.blogDetailHeaders()
    modules.navigation()
    modules.accordion()
    modules.video()
    modules.tabs()
    modules.dropdown()
    modules.scrollTo()
    modules.form()
    modules.search()
    modules.storeLocator()
    modules.notificationBar()
    modules.compare.init()
    modules.languageSwitch()
    modules.listingFilters()
    modules.blogFilters()
    modules.product()
    modules.downloadSelect()
    modules.downloadsPagination()
    modules.newsletterPopup()
    modules.languageSelectorPopup()
    modules.nitro()
    modules.nitroForms()
    modules.animatedVideo()
    modules.tagManagerEvents()
    modules.productGallery()
    modules.productSeries()
    modules.subnavHover()
    modules.siteSwitchPopup()
    modules.algolia()
})
